/* eslint-disable */

//tslint:disable

export var ESenderType = /*#__PURE__*/function (ESenderType) {
  /** SMS **/
  ESenderType["Sms"] = "sms";
  /** Звонок **/
  ESenderType["Call"] = "call";
  return ESenderType;
}({});
export var EType = /*#__PURE__*/function (EType) {
  /** Подтверждение номера телефона **/
  EType["PhoneNumber"] = "phoneNumber";
  /** Подтверждение при смене пароля **/
  EType["ChangePassword"] = "changePassword";
  /** Подтверждение при смене email'а **/
  EType["ChangeEmail"] = "changeEmail";
  /** Подтверждение при смене credit **/
  EType["ChangeCredit"] = "changeCredit";
  /** Подтверждение для бронирования объявления. **/
  EType["BookingAnnouncement"] = "bookingAnnouncement";
  /** Подтверждение для аутентификации. **/
  EType["AuthenticateCode"] = "authenticateCode";
  return EType;
}({});